import { render, staticRenderFns } from "./DailyGoal.vue?vue&type=template&id=6dbb90d8&"
import script from "./DailyGoal.ts?vue&type=script&lang=js&"
export * from "./DailyGoal.ts?vue&type=script&lang=js&"
import style0 from "./DailyGoal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports